<template>
  <b-form-group
    :invalid-feedback="department.invalidFeedback"
    :label="$t('technician.department.follow')"
    :state="department.state"
    class="medium-label mb-4"
    label-for="department-select"
  >
    <b-dropdown id="dropdown-1" text="Sélectionner des départements" class="m-md-2" variant="primary" @hide="preventDropdownHide">
      <b-form-checkbox-group v-model="department.values">
        <b-dropdown-item
          @click.stop="toggleCheckbox(option.value)"
          @click.native.stop
          v-for="option in departments"
          class="full-width-dropdown-item"
          :key="option.value"
        >
          <b-form-checkbox
            button-variant="secondary"
            @click.native.stop
            :value="option.value"
            @change="handleDepartmentChange"
          >
            {{ option.text }}
          </b-form-checkbox>
        </b-dropdown-item>
      </b-form-checkbox-group>
    </b-dropdown>

    <!-- Tags pour les éléments sélectionnés -->
    <b-form-tags
      v-model="selectedTags"
      no-input
      no-add-on-enter
      class="mb-3"
      no-outer-focus
      size="lg"
      :class="{ 'no-input': selectedTags.length === 0 }"
    >
      <template #default="{ tags, removeTag, disabled }">
        <!-- Dropdown avec les checkboxes -->
        <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-0">
          <li v-for="tag in tags" :key="tag" class="list-inline-item">
            <b-form-tag
              @remove="() => handleTagRemove(tag)"
              :title="tag"
              variant="secondary"
            >{{ getDepartmentText(tag) }}
            </b-form-tag>
          </li>
        </ul>
      </template>
    </b-form-tags>
  </b-form-group>
</template>

<script>
export default {
  props: {
    departments: {
      type: Array,
      required: true
    },
    department: {
      type: Object,
      required: true
    }
  },
  computed: {
    selectedTags() {
      return this.department.values;
    }
  },
  methods: {
    getDepartmentText(value) {
      const department = this.departments.find(dept => dept.value == value);
      return department.text
    },
    handleTagRemove(tag) {
      const index = this.department.values.indexOf(Number(tag));
      if (index !== -1) {
        this.department.values.splice(index, 1);
      }
    },

    toggleCheckbox(value) {
      this.shouldPreventHide = true;
      const index = this.department.values.indexOf(value);
      if (index === -1) {
        if (this.department.values.length > 5) {
          this.department.values = this.department.values.slice(0, 6);
          this.warnMaxDepartments();
        }
        else{
          this.department.values.push(value);
        }
      } else {
        this.department.values.splice(index, 1);
      }
    },

    itemClicked() {
      this.shouldPreventHide = true;
    },
    preventDropdownHide(evt) {
      if (this.shouldPreventHide) {
        evt.preventDefault();
        this.shouldPreventHide = false;
      }
    },


    handleDepartmentChange() {
      if (this.department.values.length > 6) {
        this.department.values = this.department.values.slice(0, 6);
        this.warnMaxDepartments();
      }
      this.askConfirm = true;
    },
    warnMaxDepartments() {
      this.$bvToast.toast(this.$i18n.t('technician.department.max.choice'), {
        autoHideDelay: 3000,
        toaster: 'b-toaster-top-center',
        noCloseButton: true,
        variant: 'info',
        solid: true
      });
    },
  }
};
</script>


<style scoped>
.was-validated .form-control:invalid, .form-control.is-invalid {
  background-image: none;
  padding-right: 0.75rem !important;
  border-width: medium;
  border-color: var(--main-color-medium);
}

.was-validated .form-control:valid, .form-control.is-valid {
  background-image: none;
  padding-right: 0.75rem !important;
  border-width: medium;
  padding-bottom: inherit;
}

</style>



// WEBPACK FOOTER //
// src/components/b122/DropdownDepartment.vue